/**
 * @generated SignedSource<<c9eda8b2e2fba5a77c806392ef4a2a5d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AddRoomToHotelInput = {
  name?: string | null;
};
export type AddRoomDialogMutation$variables = {
  connections: ReadonlyArray<string>;
  id: string;
  input: AddRoomToHotelInput;
};
export type AddRoomDialogMutation$data = {
  readonly addRoomToHotel: {
    readonly node: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"HotelEditRoomsRow_room">;
    };
  };
};
export type AddRoomDialogMutation = {
  response: AddRoomDialogMutation$data;
  variables: AddRoomDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AddRoomDialogMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "AddRoomToHotelResult",
        "kind": "LinkedField",
        "name": "addRoomToHotel",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Room",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "HotelEditRoomsRow_room"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "AddRoomDialogMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "AddRoomToHotelResult",
        "kind": "LinkedField",
        "name": "addRoomToHotel",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Room",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nameString",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "capacity",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "prependNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "node",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              },
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "RoomEdge"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "19498acf311027bbf558147915525684",
    "id": null,
    "metadata": {},
    "name": "AddRoomDialogMutation",
    "operationKind": "mutation",
    "text": "mutation AddRoomDialogMutation(\n  $id: ID!\n  $input: AddRoomToHotelInput!\n) {\n  addRoomToHotel(id: $id, input: $input) {\n    node {\n      id\n      ...HotelEditRoomsRow_room\n    }\n  }\n}\n\nfragment HotelEditRoomsRow_room on Room {\n  id\n  nameString\n  capacity\n}\n"
  }
};
})();

(node as any).hash = "f972577f7e11b3b88e2e81793f5183fc";

export default node;
